import { useState } from "react";
import ContentManager, { SingletonEditor } from "../ContentManager";

const NavigationAdmin = () => {
  const [tab, setTab] = useState("items");
  return (
    <div>
      <div className="mb-6 flex gap-2 flex-wrap" data-testid="nav-admin-tabs">
        {[["items", "Menu Items"], ["meta", "Header & Footer Settings"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`nav-tab-${k}`}
            className={`px-4 py-2 text-[11px] font-display font-semibold uppercase tracking-widest border transition-colors ${tab === k ? "bg-[#0A1128] text-white border-[#0A1128]" : "bg-white text-slate-600 border-slate-300 hover:border-slate-500"}`}>
            {l}
          </button>
        ))}
      </div>
      {tab === "items" ? (
        <ContentManager type="nav_item" title="Navigation Menu Items"
          description="Header and footer links. Set 'Parent item ID' to place an item inside a dropdown (e.g. nav-about). System routes (/admin, /app) must never be used as links here." />
      ) : (
        <SingletonEditor type="navigation_meta" />
      )}
    </div>
  );
};

export default NavigationAdmin;
